export const CONFIRMED_GET_PANCHKARMA_USERS = "CONFIRMED_GET_PANCHKARMA_USERS";
export const CONFIRMED_ADD_PANCHKARMA_USER = "CONFIRMED_ADD_PANCHKARMA_USER";
export const CONFIRMED_UPDATE_PANCHKARMA_USER = "CONFIRMED_UPDATE_PANCHKARMA_USER";
export const CONFIRMED_DELETE_PANCHAKRMA_USER = "CONFIRMED_DELETE_PANCHAKRMA_USER";
